import { Variant } from '@/redux/slices/pdpSlice';
import VariantSelector from './Variant';
import Icon from '../../../../Icon';
import { useDarkModeContext } from '../../../DarkModeContext/useDarkModeContext';
import classnames from 'classnames';

interface VariantsGroupProps {
  icon: string;
  label: string;
  variants?: Array<Variant>;
  selectedVariant?: Variant;
  waitlistLabel?: string;
  alreadyOnWaitlistCodes?: Set<string>;
  isWaitlistRegistrationsPending?: boolean;
  onSelect: (variant: Variant) => void;
}

const VariantsGroup: React.FC<VariantsGroupProps> = ({
  icon,
  label,
  variants,
  selectedVariant,
  waitlistLabel,
  alreadyOnWaitlistCodes,
  isWaitlistRegistrationsPending,
  onSelect
}) => {
  const darkmodeContext = useDarkModeContext();
  const isDarkMode = darkmodeContext?.isDarkMode ?? false;

  if (variants?.length === 0) return null;

  const sortedVariants = variants?.slice().sort((a, b) => {
    if (a.eventStartDate && b.eventStartDate) {
      return new Date(a.eventStartDate).getTime() - new Date(b.eventStartDate).getTime();
    }
    return 0;
  });

  return (
    <div data-component="VariantsGroup">
      <p
        className={classnames(
          { 'text-white': isDarkMode },
          'text-2 flex items-center gap-2 font-bold'
        )}
      >
        <Icon name={icon} />
        {label}
      </p>
      <div className="mt-6 flex flex-col gap-3 ">
        {sortedVariants?.map(variant => (
          <VariantSelector
            key={variant.code}
            location={variant.location}
            startDate={variant.eventStartDate}
            endDate={variant.eventEndDate}
            ecomBoxSessions={variant.ecomBoxSessions}
            customDuration={variant.customDuration}
            isLive={variant.isLive}
            timeZone={variant.timeZoneIdentifier}
            subLabel={
              variant.waitlist && !isWaitlistRegistrationsPending
                ? alreadyOnWaitlistCodes?.has(String(variant.code ?? '').trim())
                  ? 'You are on the Waitlist'
                  : waitlistLabel
                : undefined
            }
            selected={variant.code === selectedVariant?.code}
            onSelect={() => onSelect(variant)}
            isOnline={variant.type === 'online'}
          />
        ))}
      </div>
    </div>
  );
};

export default VariantsGroup;
